<template>
    <div>
        <div class="spinner-container p-3">
            <div>
                <b-spinner variant="primary"></b-spinner>
            </div>
            <div style="margin-left: 5px;">
                <span>{{ $gettext('Deleting your account...') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import DashboardService from "@/store/services/dashboard.service"
import { mapGetters } from "vuex"

export default {
    name: 'DeleteAccount',
    components: {},
    computed: {
        ...mapGetters({
            isAuthenticated: "auth/getAuthenticated"
        })
    },
    mounted() {
        let token = this.$route.params['uuid']

        if (!this.isAuthenticated) {
            window.location.href = window.Urls['accounts_login']() + "?delete_account=true&token=" + token
        }

        DashboardService.accessTokenDeleteProfile({'delete_token': token}).then((response) => {
            if (response.status === 204) {
                // this.$router.push({ name: 'DashboardDeleteAccount', params: {uuid: token} })
                window.location.href = window.Urls['gekko_dashboard_delete'](token)

            }
        }).catch((error) => {
            let msg = ''
            if (error.status == 404) {
                msg = this.$gettext('We could not find this token. Try copy/pasting the exact link.')
            } else if (error.status == 403) {
                msg = this.$gettext('You are logged in to the wrong account. Please log in with the account for which this link was requested.')
            } else {
                msg = this.$gettext('Unkown error')
            }
            this.$store.commit('setAlert', { title: this.$gettext('Error deleting account'), text: msg, variant: 'danger', duration: 4 })
        })
    }
}
</script>

<style scoped>
.spinner-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
</style>